import { submissionStatus, completionType } from '@/utils/locale'

export function isFullApproved (submission) {
  return submission.status === submissionStatus.APPR &&
      this.isFinalSubmission(submission)
}

export function isFinalSubmission (submission, hasRetention) {
  const retentionPaymentType = [completionType.FULL, completionType.FINAL_PAYMENT, completionType.RETENTION]
  const isNoRetentionFinal = submission.completionType === completionType.FINAL_PARTIAL && !hasRetention
  const isRetentionFinal = retentionPaymentType.includes(submission.completionType)
  const isFinal = isNoRetentionFinal || isRetentionFinal
  return isFinal
}

export function isRetentionPaymentSr (type) {
  const retentionType = [completionType.RETENTION_PAYMENT, completionType.FINAL_PAYMENT, completionType.RETENTION]
  return retentionType.includes(type)
}
